<template>
    <div v-if="!isConsentGiven" class="cookie-banner">
        <p>
            Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre
            <a :href="`${authUrl}/politique-confidentialite`" target="_blank" rel="noopener noreferrer">politique de confidentialité</a>.
        </p>
        <div class="actions">
            <button @click="acceptCookies">Accepter</button>
            <button @click="rejectCookies">Refuser</button>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useAuthStore } from '../stores/useAuthStore'
import { auth_url as authUrl } from '../config/config'

const authStore = useAuthStore()

const isConsentGiven = computed(() => authStore.cookieConsent !== null)

onMounted(() => {
    window.addEventListener('open-cookie-banner', reopenBanner)
})

onBeforeUnmount(() => {
    window.removeEventListener('open-cookie-banner', reopenBanner)
})

const reopenBanner = () => {
    authStore.resetConsent()
}

const acceptCookies = () => {
    authStore.acceptCookies()
}

const rejectCookies = () => {
    authStore.rejectCookies()
}
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 10px;
    width: 80%;
    background: var(--color-light-shadow);
    color: var(--color-fg);
    text-align: center;
    border-radius: var(--radius);
    padding: 1rem;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
}

.actions {
    margin-top: 0.5rem;
}

button {
    background: var(--color-mascot);
    color: white;
}

button:hover {
    background: var(--color-success);
}
</style>